import { Link } from "react-router-dom";
const InvoiceTabs = (props) => {
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item" role="presentation">
        <Link
          to={"/saleinvoice"}
          className={
            props.pageName === "SALEINVOICE"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          SALE INVOICE
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/salelist"}
          className={
            props.pageName === "SALELIST"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          SALE LIST
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/purchaseinvoice"}
          className={
            props.pageName === "PURCHASEINVOICE"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          PURCHASE INVOICE
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/purchaselist"}
          className={
            props.pageName === "PURCHASELIST"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          PURCHASE LIST
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/expenseinvoice"}
          className={
            props.pageName === "EXPENSEINVOICE"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          EXPENSE INVOICE
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/expenselist"}
          className={
            props.pageName === "EXPENSELIST"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          EXPENSE LIST
        </Link>
      </li>
    </ul>
  );
};

export default InvoiceTabs;
